import { Button, Col, Descriptions, Row, Space, Checkbox, Form } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';



const ConfirmationStep = ({ goPrev, form, catLocalidades, loading }) => {
    const values = form.getFieldsValue(true);

    const handleFinish = async () => {
        try {
            await form.validateFields();
            form.submit();
        }
        catch (error) {
            //console.log(error);
        }
    };

    return (
        <>
            <Row gutter={[16, 16]} justify="center">
                <Col xs={24} sm={20}>
                    <Descriptions column={1} bordered size="small" style={{ marginBottom: 16 }}>
                        <Descriptions.Item label="CURP">{values.curp}</Descriptions.Item>
                        <Descriptions.Item label="Matrícula">{values.matricula}</Descriptions.Item>
                        <Descriptions.Item label="Teléfono">{values.telefono_personal}</Descriptions.Item>
                        <Descriptions.Item label="Correo Personal">{values.correo_personal}</Descriptions.Item>
                        {/*<Descriptions.Item label="Correo institucional">
                            {values?.correo_institucional ?? 'No disponible'}
                        </Descriptions.Item>*/}
                        <Descriptions.Item label="Contraseña">{values.password.slice(0, 2) + '*'.repeat(values.password.length - 2)}</Descriptions.Item>
                        <Descriptions.Item label="Dirección">
                            {`${values.calle_y_numero}, ${catLocalidades.find(item => item.id === values.id_colonia)?.data} , ${values.municipio}, ${values.estado}, CP ${values.codigo_postal}`}
                        </Descriptions.Item> 
                    </Descriptions>
                </Col>
            </Row>
            <Row gutter={[16, 16]} align="middle" justify="center">
                <Col xs={24} sm={20} align="center">
                    <Form.Item
                        name="terminos_aceptados"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value
                                        ? Promise.resolve()
                                        : Promise.reject('Debes de aceptar el aviso de privacidad'),
                            },
                        ]}
                    >
                        <Checkbox>
                            He leído y acepto el <a target="_blank" href="https://conalepmexedu-my.sharepoint.com/:b:/g/personal/contenido-portal_conalepmex_edu_mx/Ee2OWIeyxX5Gg5GXjyAOMHsBz9m9Zw7PMRzxCwW-N5tU8w?e=8x4aho">
                                 Aviso de Privacidad
                            </a>
                            </Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 16]} align="middle" justify="center" style={{ marginTop: 16 }}>
                <Col xs={24} sm={20} align="center">
                    <Space justify="space-evenly">
                        <Button icon={<ArrowLeftOutlined />} onClick={goPrev} loading={loading}>Atrás</Button>
                        <Button type="primary" icon={<SaveOutlined />} onClick={handleFinish} loading={loading}>
                            Finalizar Registro
                        </Button>
                    </Space>
                </Col>
            </Row>
        </>
    );
};

export default ConfirmationStep;
